import { useState } from "react"

import GenericTabStrip from "../../../components/tabs/tabs"

import ActionButtons from "../../../components/action-buttons/action-buttons"


const RightContent = ( { selectedGridRow = { name:"test" , id:123 } } ) => {
    const [tabs, setTabs] = useState([
    { id: "tab2", title: "Analysis Set", content:<span></span> },
    { id: "tab3", title: "Demographics and Baseline", content: <div></div>, },
    { id: "tab4", title: "Medical History", content: <div></div>, },
    { id: "tab5", title: "Concomitant Medication", content: <div></div>, },
    { id: "tab6", title: "Endpoint", content: <div></div>, },
    { id: "tab7", title: "Statistical Methods", content: <div></div>, },
    { id: "tab8", title: "Adverse Events", content: <div></div>, },
  ]);

  const handleTabChange = (tab, idx) => {
    console.log("Selected tab:", tab, "Index:", idx);
  };
  return (
    <div className='prompt-right-con'>
        <div className='header'> <span> { selectedGridRow.name } </span> </div>
         {
           (selectedGridRow.id == 1 || selectedGridRow.id == 2 || selectedGridRow.id == 5)
           &&
            <>
                <div className='body'></div>
            </>
         }
         {
           (selectedGridRow.id == 3 || selectedGridRow.id == 4) &&
             <div style={{height:"90%",width:"100%"}}>
                 <GenericTabStrip
                  tabs={tabs}
                  onTabChange={handleTabChange}
                  closable={false}
                  style = { { height:"100%" , marginTop:"5px" }}
                  />
             </div>
         }
         <div className='btn-con'>
           <ActionButtons/>
         </div>
    </div>
  )
}

export default RightContent